import { Command1 } from "../../../../../Command";
import { SensorsDataResult, GetSensorsDataFn } from "../../../../../rest/Geotab";
import { FlagActions } from "../../../../flux/Flag/FlagActions";
import { ErrorActions } from "../../../../flux/Error/ErrorActions";
import { Key } from "../../../../../models";

export class LoadSensorsDataCommand implements Command1<string>
{
    private readonly flagActions = new FlagActions();
    private readonly errorActions = new ErrorActions();
    
    constructor(
        private getSensorsData: GetSensorsDataFn,
        private getIds: () => Key[],
        private showSensorsDataCmd: Command1<SensorsDataResult>,
        private inProgressDispatchToken: string, private errorDispatchToken: string)
    {
    }
    
    execute = (timeRange: string) => {
        this.flagActions.set(this.inProgressDispatchToken);
        
        const task = this.getSensorsData(this.getIds(), timeRange)
            .then(this.showSensorsDataCmd.execute)
            .catch(err => this.errorActions.setError(err, this.errorDispatchToken, 5 * 1000))
            .then(() => this.flagActions.reset(this.inProgressDispatchToken)); // finally
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Sensor/commands/LoadSensorsDataCommand.ts